import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { EditUsesPopupComponent, IUseLabelEditData } from '../../../../../app/import-page/import/data-table/edit-uses-popup/edit-uses-popup.component';

@Component({
    standalone: false,
    selector: 'app-create-use-button',
    templateUrl: './create-use-button.component.html',
    styleUrls: ['./create-use-button.component.scss']

})
export class CreateUseButtonComponent {

    @Input()
    public table: any;

    @Input()
    public zoningCodeId: number;

    constructor(public dialog: MatDialog) {
    }

    public openDialog(): void {
        const data: IUseLabelEditData = {
            tables: this.table,
            zoningCodeId: this.zoningCodeId
        };
        this.dialog.open(EditUsesPopupComponent, {
            height: '400px',
            width: '500px',
            data
        });
    }
}
